import { createBrowserHistory, createMemoryHistory } from 'history';
import config from '../config';

const isTest = config.nodeEnv === 'test';

export const history = isTest ? createMemoryHistory({ initialEntries: ['/'] }) : createBrowserHistory();
